import { DynamicDateRangePanel } from '../dynamic-date-range-panel';
import { withSingleDynamicDate } from './withSingleDynamicDate';
export * from './types';
export * from './withSingleDynamicDate';
export var DynamicDatePanel = withSingleDynamicDate(DynamicDateRangePanel);